var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.errorMsg !== null)?_c('ErrorMessage',{attrs:{"msg":_vm.errorMsg}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }